var exports = {
  "qs": "mergeboxLoading__A-z7na",
  "th": "hideBorder__1jtTl9",
  "pF": "mergePartialContainer__VUMolp",
  "Qm": "mergeBoxAdjustBorders__A-iNVH",
};

module.exports = exports;
